import React from "react";

type FormGroupProps = {
  className?:string,
  children?: React.ReactNode
};

const FormGroup = ({children}:FormGroupProps) => {
  return <div className={`form_group_row flex items-start justify-between`}>{children}</div>
}
const FormGroupLabel = ({children,className}:FormGroupProps) => {
  return (<div className={`form_label body1 flex items-center ${className}`}>{children}</div>)
}
const FormGroupValue = ({children,className}:FormGroupProps) => {
  return (<div className={`form_btn body1_sb text-right flex items-center ${className}`}>{children}</div>)
}


FormGroup.Label = FormGroupLabel;
FormGroup.Value = FormGroupValue;

export default FormGroup;